<!-- @veltra/icons generated sha256:1fdeef2ccaed632b gen:8 source:src/svg/normal/rollfront.svg -->
<script setup lang="ts">
defineOptions({ name: 'Rollfront' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m12.086 5-1.291-1.29a.49.49 0 0 1-.013-.7l.021-.02A.486.486 0 0 1 11.5 3c.69.688 2.147 2.146 2.147 2.146a.5.5 0 0 1 0 .708L11.5 8a.486.486 0 0 1-.696.01l-.02-.022a.49.49 0 0 1 .012-.698L12.085 6H6.294a3 3 0 0 0 0 6h4.504a.5.5 0 0 1 0 1H6.293a4 4 0 0 1 0-8z"
    />
  </svg>
</template>
